/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { ViewType } from '@airasia-phoenix/react-native/components/SearchableListPageView';
import { getCurrentBreakpoint } from '@airasia-rn/ui/utils';
export const getSelectionFieldViewType = (
  isPortalUsageEnabled: boolean,
  // Callers rendered on the server pass a hydration-safe value: the live
  // breakpoint is `md` on the server but the real window size on the client.
  isDesktopView: boolean = getCurrentBreakpoint() > 1,
) => {
  return isDesktopView
    ? isPortalUsageEnabled
      ? ViewType.DropDownWithPortal
      : ViewType.DropDown
    : ViewType.BottomSheet;
};
